import { Box, Typography } from "@mui/material";
import Slider from "react-slick";
import UserProfileHoverDialog from "../memeverse/feed/UserProfileHoverDialog";
import { testimonialDataProd } from "./socialProofData"
import { useMemo } from "react";
import "./socialProof.css";

const SocialProof: React.FC = () => {

  const bannerSettings = {
    className: "center-slider",
    centerMode: true,
    infinite: true,
    centerPadding: "110px",
    slidesToShow: 3,
    speed: 2000,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
  };

  const isStaging = useMemo(() => {
    return window.location.hostname.includes('staging') ||
      window.location.hostname.includes('localhost')
  }, []);

  const testimonials = isStaging ? testimonialDataProd : testimonialDataProd;

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      width='100%'
      sx={{
        gap: {xs: 3, md: 4},
        px: 1.5,
        py: {xs: 3, md: 4},
        overflowX: 'clip',
        maxWidth: "lg",
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" >
          What our experts are saying
        </Typography>
        <Typography variant="body1" color="text.secondary" >
          Some may have asked their AI Personas to write theirs for them
        </Typography>
      </Box>

      <Box
        position='relative'
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          maxWidth: 'none',
          width: '1200px',
        }}
      >
        <Slider {...bannerSettings}>
          {
            testimonials.map((testimonial, ind) => {
              return (
                <UserCard
                  key={`testimonial-${ind}`}
                  testimonial={testimonial}
                />
              )
            })
          }
        </Slider>
      </Box>
    </Box>
  )
}

export default SocialProof;

interface UserCardProps {
  testimonial: {
    user_details: {
      fullName: string;
      profilePicUrl: string;
      shortBio: string;
      userName: string;
      user_id: string;
      is_creator: boolean;
    };
    title: string;
    content: string;
  }
}

const UserCard: React.FC<UserCardProps> = ({testimonial}) => {

  const {
    user_details,
    title,
    content
  } = testimonial || {};


  return (
    <Box
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 2,
        backgroundColor: (theme) => theme.palette.background["container-2"],
        borderRadius: 1.5,
        maxWidth: '300px',
        height: '100%',
      }}
    >
      <UserProfileHoverDialog
        post_user_details={user_details}
        is_requester_following={false}
        show_following={false}
        ai_agent={false}
      />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <Typography variant="h7">
            {user_details.fullName}
          </Typography>
          <Typography variant="body3" color="text.secondary">
            {title}
          </Typography>
        </Box>
        <Typography variant="body1">
          {content}
        </Typography>
      </Box>
    </Box>
  )
}
